import { render, staticRenderFns } from "./goods-vip-forever-protocol20231108.vue?vue&type=template&id=77569b4c&scoped=true"
import script from "./goods-vip-forever-protocol20231108.vue?vue&type=script&lang=js"
export * from "./goods-vip-forever-protocol20231108.vue?vue&type=script&lang=js"
import style0 from "./goods-vip-forever-protocol20231108.vue?vue&type=style&index=0&id=77569b4c&prod&lang=scss"
import style1 from "./goods-vip-forever-protocol20231108.vue?vue&type=style&index=1&id=77569b4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77569b4c",
  null
  
)

export default component.exports